/* eslint-disable no-unused-vars, prefer-object-spread, no-mixed-operators,
no-unneeded-ternary, arrow-body-style, max-len */
import {
  InitScale, InitAxisCall, InitTip,
} from '../../helpers/init';
import {
  MountPath, MountGrid, MountAxis, MountAxisLabelX, MountAxisLabelY,
  MountClip, MountMainFrame, MountTags, MountComparePath, MountRef,
  MountThresLine,
} from '../../helpers/mount';
import { PksEdit, PeckersEdit } from '../../helpers/converter';
import MountBrush from '../../helpers/brush';
import { TfRescale, MountCompass } from '../../helpers/compass';
import {
  buildIntegrationBarData,
  drawIntegrationAUC,
  drawVisualSplitLinesForFocus,
  handleIntegrationClick,
  handleIntegrationMouseMove,
} from '../../helpers/integration_focus';
import { clearIntegrationSplitPreview } from '../../helpers/integration_split';
import { LIST_LAYOUT } from '../../constants/list_layout';
import Format from '../../helpers/format';
import {
  GetCyclicVoltaPreviousShift, convertTopic,
} from '../../helpers/chem';
import Cfg from '../../helpers/cfg';
import { itgIdTag, mpyIdTag } from '../../helpers/focus';
import {
  calcArea,
} from '../../helpers/integration';
import { calcMpyCenter } from '../../helpers/multiplicity_calc';

const d3 = require('d3');

class MultiFocus {
  constructor(props) {
    const {
      W, H, clickUiTargetAct, selectUiSweepAct, scrollUiWheelAct, entities, uiSt,
      splitIntegrationAct, addVisualSplitLineAct, removeVisualSplitLineAct,
    } = props;
    this.uiSt = uiSt;
    this.graphIndex = uiSt?.zoom?.graphIndex;
    this.entities = entities;
    this.jcampIdx = 0;
    this.isShowAllCurves = false;
    this.rootKlass = '.d3Line';
    this.margin = {
      t: 5,
      b: 40,
      l: 60,
      r: 5,
    };
    this.w = W - this.margin.l - this.margin.r;
    this.h = H - this.margin.t - this.margin.b;
    this.clickUiTargetAct = clickUiTargetAct;
    this.selectUiSweepAct = selectUiSweepAct;
    this.scrollUiWheelAct = scrollUiWheelAct;
    this.splitIntegrationAct = splitIntegrationAct;
    this.addVisualSplitLineAct = addVisualSplitLineAct;
    this.removeVisualSplitLineAct = removeVisualSplitLineAct;
    this.brush = d3.brush();
    this.brushX = d3.brushX();

    this.axis = null;
    this.path = null;
    this.thresLineUp = null;
    this.thresLineDw = null;
    this.grid = null;
    this.tags = null;
    this.ref = null;
    this.data = [];
    this.otherLineData = [];
    this.pathColor = 'steelblue';
    this.dataPks = [];
    this.dataPeckers = [];
    this.tTrEndPts = null;
    this.tSfPeaks = null;
    this.root = null;
    this.svg = null;
    this.axisCall = InitAxisCall(5);
    this.pathCall = null;
    this.tip = null;
    this.factor = 0.125;
    this.currentExtent = null;
    this.shouldUpdate = {};
    // this.freq = false;
    this.layout = LIST_LAYOUT.CYCLIC_VOLTAMMETRY;
    this.isUiAddIntgSt = false;
    this.isUiSplitIntgSt = false;
    this.isUiVisualSplitIntgSt = false;
    this.integrationSplitTargets = null;
    this.firstIntegrationPoint = null;

    this.getShouldUpdate = this.getShouldUpdate.bind(this);
    this.resetShouldUpdate = this.resetShouldUpdate.bind(this);
    this.setTip = this.setTip.bind(this);
    this.setDataParams = this.setDataParams.bind(this);
    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.setConfig = this.setConfig.bind(this);
    this.drawLine = this.drawLine.bind(this);
    this.drawThres = this.drawThres.bind(this);
    this.drawOtherLines = this.drawOtherLines.bind(this);
    this.drawGrid = this.drawGrid.bind(this);
    this.drawPeaks = this.drawPeaks.bind(this);
    this.drawRef = this.drawRef.bind(this);
    this.drawInteg = this.drawInteg.bind(this);
    this.drawMtply = this.drawMtply.bind(this);
    this.drawAUC = this.drawAUC.bind(this);
    this.onClickTarget = this.onClickTarget.bind(this);
    this.onClickIntegrationTarget = this.onClickIntegrationTarget.bind(this);
    this.onIntegrationMouseMove = this.onIntegrationMouseMove.bind(this);
    this.clearSplitPreview = this.clearSplitPreview.bind(this);
    this.drawVisualSplitLines = this.drawVisualSplitLines.bind(this);
    this.mergedPeaks = this.mergedPeaks.bind(this);
    this.setDataPecker = this.setDataPecker.bind(this);
    this.drawPeckers = this.drawPeckers.bind(this);
    this.onClickPecker = this.onClickPecker.bind(this);
    this.isFirefox = typeof InstallTrigger !== 'undefined';
    this.cyclicvoltaSt = null;
    this.yTransformFactor = 1.0;
  }

  getShouldUpdate(nextEpSt) {
    const {
      prevXt, prevYt, prevEpSt, prevLySt,
      prevTePt, prevDtPk, prevSfPk, prevData, prevYFactor,
    } = this.shouldUpdate;
    const { xt, yt } = TfRescale(this);
    const sameXY = xt(1.1) === prevXt && prevYt === yt(1.1);
    const sameEpSt = prevEpSt === nextEpSt;
    const sameLySt = prevLySt === this.layout;
    const sameTePt = prevTePt === this.tTrEndPts.length;
    const sameDtPk = prevDtPk === this.dataPks.length;
    const sameSfPk = prevSfPk === this.tSfPeaks
      || (
        Array.isArray(prevSfPk)
        && Array.isArray(this.tSfPeaks)
        && prevSfPk.length === this.tSfPeaks.length
        && prevSfPk.every((peak, idx) => peak === this.tSfPeaks[idx])
      );
    const sameData = prevData === this.data.length;
    const sameYFactor = prevYFactor === this.yTransformFactor;
    this.shouldUpdate = Object.assign(
      {},
      this.shouldUpdate,
      {
        sameXY, sameEpSt, sameLySt, // eslint-disable-line
        sameTePt, sameDtPk, sameSfPk, sameData, sameYFactor, // eslint-disable-line
      },
    );
  }

  resetShouldUpdate(prevEpSt) {
    const { xt, yt } = TfRescale(this);
    const prevXt = xt(1.1);
    const prevYt = yt(1.1);
    const prevTePt = this.tTrEndPts.length;
    const prevDtPk = this.dataPks.length;
    const prevSfPk = this.tSfPeaks;
    const prevData = this.data.length;
    const prevLySt = this.layout;
    const prevYFactor = this.yTransformFactor;
    this.shouldUpdate = Object.assign(
      {},
      this.shouldUpdate,
      {
        prevXt, prevYt, prevEpSt, prevLySt, // eslint-disable-line
        prevTePt, prevDtPk, prevSfPk, prevData, prevYFactor, // eslint-disable-line
      },
    );
  }

  setTip() {
    this.tip = InitTip();
    this.root.call(this.tip);
  }

  computeYTransformFactor(layout, cyclicvoltaSt, feature) {
    let factor = 1.0;
    if (layout === LIST_LAYOUT.CYCLIC_VOLTAMMETRY && cyclicvoltaSt && cyclicvoltaSt.useCurrentDensity) {
      const rawArea = (cyclicvoltaSt.areaValue === '' ? 1.0 : cyclicvoltaSt.areaValue) || 1.0;
      const areaUnit = cyclicvoltaSt.areaUnit || 'cm²';
      const safeArea = rawArea > 0 ? rawArea : 1.0;
      // areaInCm2 already converts mm² → cm², so factor is A/cm². Do NOT divide by 100 again.
      const areaInCm2 = areaUnit === 'mm²' ? (safeArea / 100.0) : safeArea;
      factor = 1.0 / areaInCm2;
      const baseY = feature && feature.yUnit ? String(feature.yUnit) : 'A';
      if (/mA/i.test(baseY)) {
        factor *= 1000.0;
      }
    }
    return factor;
  }

  transformYValue(y) {
    return y * this.yTransformFactor;
  }

  setDataParams(filterSeed, peaks, tTrEndPts, tSfPeaks, layout, cyclicvoltaSt, jcampIdx = 0) {
    this.data = [];
    this.otherLineData = [];
    let filterSubLayoutValue = null;

    const currFeature = this.entities && this.entities[0] ? this.entities[0].feature : null;
    this.yTransformFactor = this.computeYTransformFactor(layout, cyclicvoltaSt, currFeature);

    this.entities.forEach((entry, idx) => {
      const { topic, feature, color } = entry;
      const offset = GetCyclicVoltaPreviousShift(cyclicvoltaSt, jcampIdx);
      let currData = convertTopic(topic, layout, feature, offset);
      if (idx === jcampIdx) {
        if (!Format.isCyclicVoltaLayout(layout)) {
          currData = filterSeed;
        }
        this.data = [...currData];
        this.pathColor = color;
        filterSubLayoutValue = Format.isSECLayout(layout) ? feature.xUnit : feature.yUnit;
      } else {
        const filterValue = Format.isSECLayout(layout) ? feature.xUnit : feature.yUnit;
        this.otherLineData.push({ data: currData, color, filterSublayout: filterValue });
      }
    });
    if (Format.isSECLayout(layout) || Format.isGCLayout(layout)) {
      this.otherLineData = this.otherLineData.filter((data) => {
        return data.filterSublayout === filterSubLayoutValue;
      });
    }

    if (this.jcampIdx === jcampIdx) {
      this.dataPks = [...peaks];
    } else {
      this.dataPks = peaks;
    }
    this.tTrEndPts = tTrEndPts;
    this.tSfPeaks = tSfPeaks;
    this.layout = layout;
    this.cyclicvoltaSt = cyclicvoltaSt;
    this.jcampIdx = jcampIdx;
  }

  updatePathCall(xt, yt) {
    this.pathCall = d3.line()
      .x((d) => xt(d.x))
      .y((d) => yt(d.y));
  }

  setYAxisTickFormat() {
    const f = this.yTransformFactor || 1;
    const format = d3.format('.2n');
    this.axisCall.y.tickFormat((v) => format(v * f));
  }

  setConfig(sweepExtentSt) {
    // Domain Calculate
    let { xExtent, yExtent } = sweepExtentSt || { xExtent: false, yExtent: false };

    if (!xExtent || !yExtent) {
      let allData = [...this.data];
      if (this.otherLineData) {
        this.otherLineData.forEach((lineData) => {
          allData = [...allData, ...lineData.data];
        });
      }

      const xes = d3.extent(allData, (d) => d.x).sort((a, b) => a - b);
      xExtent = { xL: xes[0], xU: xes[1] };
      const btm = d3.min(allData, (d) => d.y);
      const top = d3.max(allData, (d) => d.y);
      const height = top - btm;
      yExtent = {
        yL: (btm - this.factor * height),
        yU: (top + this.factor * height),
      };
    }

    this.scales.x.domain([xExtent.xL, xExtent.xU]);
    this.scales.y.domain([yExtent.yL, yExtent.yU]);

    // rescale for zoom
    const { xt, yt } = TfRescale(this);

    // Axis Call
    this.axisCall.x.scale(xt);
    this.axisCall.y.scale(yt);
    if (this.layout === LIST_LAYOUT.CYCLIC_VOLTAMMETRY) {
      this.setYAxisTickFormat();
    }

    this.currentExtent = { xExtent, yExtent };
  }

  drawLine() {
    const { xt, yt } = TfRescale(this);
    this.updatePathCall(xt, yt);
    this.path.attr('d', this.pathCall(this.data));
    this.path.style('stroke', this.pathColor);
    if (this.layout === LIST_LAYOUT.AIF) {
      this.path.attr('marker-mid', 'url(#arrow-left)');
    } else {
      this.path.attr('marker-mid', null);
    }
  }

  drawThres() {
    if (this.tTrEndPts.length > 0) {
      this.thresLineUp.attr('d', this.pathCall(this.tTrEndPts));
      this.thresLineUp.attr('visibility', 'visible');
      const [left, right] = this.tTrEndPts;
      const dwMirrorEndPts = [
        Object.assign({}, left, { y: -left.y }),
        Object.assign({}, right, { y: -right.y }),
      ];
      this.thresLineDw.attr('d', this.pathCall(dwMirrorEndPts));
      this.thresLineDw.attr('visibility', 'visible');
    } else {
      this.thresLineUp.attr('visibility', 'hidden');
      this.thresLineDw.attr('visibility', 'hidden');
    }
  }

  drawOtherLines(layout) {
    d3.selectAll('.line-clip-compare').remove();
    if (!this.otherLineData) return null;
    this.otherLineData.forEach((entry, idx) => {
      const { data, color } = entry;
      const pathColor = color ? color : Format.mutiEntitiesColors(idx);
      const path = MountComparePath(this, pathColor, idx, 0.4);
      path.attr('d', this.pathCall(data));
      if (this.layout === LIST_LAYOUT.AIF && this.isShowAllCurves === true) {
        path.attr('marker-mid', 'url(#arrow-left)');
      } else {
        path.attr('marker-mid', null);
      }
    });
    return null;
  }

  drawGrid() {
    const { sameXY, sameYFactor } = this.shouldUpdate;
    if (sameXY && sameYFactor) return;

    this.grid.x.call(this.axisCall.x
      .tickSize(-this.h, 0, 0))
      .selectAll('line')
      .attr('stroke', '#ddd')
      .attr('stroke-opacity', 0.6)
      .attr('fill', 'none');
    this.grid.y.call(this.axisCall.y
      .tickSize(-this.w, 0, 0))
      .selectAll('line')
      .attr('stroke', '#ddd')
      .attr('stroke-opacity', 0.6)
      .attr('fill', 'none');
  }

  onClickTarget(event, data) {
    event.stopPropagation();
    event.preventDefault();
    const onPeak = true;
    if (this.layout === LIST_LAYOUT.CYCLIC_VOLTAMMETRY) {
      const { spectraList } = this.cyclicvoltaSt;
      const spectra = spectraList[this.jcampIdx];
      const voltammetryPeakIdx = spectra.selectedIdx;
      this.clickUiTargetAct(data, onPeak, voltammetryPeakIdx, this.jcampIdx);
    } else {
      this.clickUiTargetAct(data, onPeak, false, this.jcampIdx);
    }
  }

  clearSplitPreview() {
    clearIntegrationSplitPreview(this);
  }

  onIntegrationMouseMove(event, data, shift, ignoreRef) {
    handleIntegrationMouseMove(this, event, data, shift, ignoreRef);
  }

  onClickIntegrationTarget(event, data) {
    handleIntegrationClick(this, event, data, (clickEvent, clickData) => {
      this.onClickTarget(clickEvent, clickData);
    });
  }

  drawVisualSplitLines(stack, shift, ignoreRef) {
    drawVisualSplitLinesForFocus(this, stack, shift, ignoreRef);
  }

  drawAUC(stack, shift = 0) {
    drawIntegrationAUC(this, stack, shift);
  }

  onClickPecker(event, data) {
    event.stopPropagation();
    event.preventDefault();
    const onPecker = true;
    const { spectraList } = this.cyclicvoltaSt;
    const spectra = spectraList[this.jcampIdx];
    const voltammetryPeakIdx = spectra.selectedIdx;
    this.clickUiTargetAct(data, false, voltammetryPeakIdx, this.jcampIdx, onPecker);
  }

  mergedPeaks(editPeakSt) {
    if (!editPeakSt) return this.dataPks;
    const { spectraList } = this.cyclicvoltaSt;
    const spectra = spectraList[this.jcampIdx];
    if (spectra) {
      this.dataPks = [];
      this.dataPks = PksEdit(this.dataPks, editPeakSt, spectra.list);
    } else {
      const newEditPeaks = Object.assign({}, editPeakSt, { selectedIdx: this.jcampIdx });
      this.dataPks = PksEdit(this.dataPks, newEditPeaks, []);
    }
    return this.dataPks;
  }

  setDataPecker() {
    const { spectraList } = this.cyclicvoltaSt;
    const spectra = spectraList[this.jcampIdx];
    if (spectra) {
      this.dataPeckers = PeckersEdit(spectra.list);
    }
    return this.dataPeckers;
  }

  drawPeaks(editPeakSt) {
    const {
      sameXY, sameEpSt, sameDtPk, sameSfPk,
    } = this.shouldUpdate;

    if (!Format.isCyclicVoltaLayout(this.layout)
    && sameXY && sameEpSt && sameDtPk && sameSfPk) return;

    // rescale for zoom
    const { xt, yt } = TfRescale(this);
    const dPks = this.mergedPeaks(editPeakSt);

    const { spectraList } = this.cyclicvoltaSt;
    const spectra = spectraList[this.jcampIdx];
    let indexOfCVRefPeaks = [];
    if (spectra) {
      const { shift, hasRefPeak } = spectra;
      const { ref } = shift;
      if (ref && hasRefPeak) {
        const { min, max } = ref;
        indexOfCVRefPeaks = dPks.map((p, index) => {
          return p === min || p === max ? -1 : index;
        });
      }
    }

    const mpp = this.tags.pPath.selectAll('path').data(dPks);
    mpp.exit()
      .attr('class', 'exit')
      .remove();

    const linePath = [
      { x: -0.5, y: 10 },
      { x: -0.5, y: -20 },
      { x: 0.5, y: -20 },
      { x: 0.5, y: 10 },
    ];
    const lineSymbol = d3.line()
      .x((d) => d.x)
      .y((d) => d.y)(linePath);

    const lineRefPath = [
      { x: -0.5, y: 10 },
      { x: -4, y: -20 },
      { x: 4, y: -20 },
      { x: 0.5, y: 10 },
    ];

    const lineSymbolRef = d3.line()
      .x((d) => d.x)
      .y((d) => d.y)(lineRefPath);

    mpp.enter()
      .append('path')
      .attr('d', (_, index) => {
        return indexOfCVRefPeaks[index] === -1 ? lineSymbolRef : lineSymbol;
      })
      .attr('class', 'enter-peak')
      .attr('fill', (_, index) => {
        return indexOfCVRefPeaks[index] === -1 ? 'blue' : 'red';
      })
      .attr('stroke', 'pink')
      .attr('stroke-width', 3)
      .attr('stroke-opacity', 0.0)
      .merge(mpp)
      .attr('id', (d) => `mpp${Math.round(1000 * d.x)}`)
      .attr('transform', (d) => `translate(${xt(d.x)}, ${yt(d.y)})`)
      .on('mouseover', (event, d) => {
        d3.select(`#mpp${Math.round(1000 * d.x)}`)
          .attr('stroke-opacity', '1.0');
        d3.select(`#bpt${Math.round(1000 * d.x)}`)
          .style('fill', 'blue');
        const tipParams = { d, layout: this.layout, yFactor: this.yTransformFactor };
        this.tip.show(tipParams, event.target);
      })
      .on('mouseout', (event, d) => {
        d3.select(`#mpp${Math.round(1000 * d.x)}`)
          .attr('stroke-opacity', '0.0');
        d3.select(`#bpt${Math.round(1000 * d.x)}`)
          .style('fill', 'red');
        const tipParams = { d, layout: this.layout, yFactor: this.yTransformFactor };
        this.tip.hide(tipParams, event.target);
      })
      .on('click', (event, d) => this.onClickTarget(event, d));

    const ignoreRef = Format.isHplcUvVisLayout(this.layout);
    if (ignoreRef) {
      const bpTxt = this.tags.bpTxt.selectAll('text').data(dPks);
      bpTxt.exit()
        .attr('class', 'exit')
        .remove();

      bpTxt.enter()
        .append('text')
        .attr('class', 'peak-text')
        .attr('font-family', 'Helvetica')
        .style('font-size', '12px')
        .attr('fill', '#228B22')
        .style('text-anchor', 'middle')
        .merge(bpTxt)
        .attr('id', (d) => `mpp${Math.round(1000 * d.x)}`)
        .text((d) => d.x.toFixed(2))
        .attr('transform', (d) => `translate(${xt(d.x)}, ${yt(d.y) - 25})`)
        .on('click', (event, d) => this.onClickTarget(event, d));
    }

    mpp.attr('fill', (_, index) => {
      return indexOfCVRefPeaks[index] === -1 ? 'blue' : 'red';
    });

    mpp.attr('d', (_, index) => {
      return indexOfCVRefPeaks[index] === -1 ? lineSymbolRef : lineSymbol;
    });
  }

  drawPeckers() {
    const {
      sameXY, sameEpSt, sameDtPk, sameSfPk,
    } = this.shouldUpdate;

    if (!Format.isCyclicVoltaLayout(this.layout) && sameXY
    && sameEpSt && sameDtPk && sameSfPk) return;

    // rescale for zoom
    const { xt, yt } = TfRescale(this);
    const dPks = this.setDataPecker();

    const mpp = this.tags.peckerPath.selectAll('path').data(dPks);
    mpp.exit()
      .attr('class', 'exit')
      .remove();

    const linePath = [
      { x: -0.5, y: 10 },
      { x: -0.5, y: -20 },
      { x: 0.5, y: -20 },
      { x: 0.5, y: 10 },
    ];
    const lineSymbol = d3.line()
      .x((d) => d.x)
      .y((d) => d.y)(linePath);

    mpp.enter()
      .append('path')
      .attr('d', lineSymbol)
      .attr('class', 'enter-peak')
      .attr('fill', '#228B22')
      .attr('stroke', 'pink')
      .attr('stroke-width', 3)
      .attr('stroke-opacity', 0.0)
      .merge(mpp)
      .attr('id', (d) => `mpp${Math.round(1000 * d.x)}`)
      .attr('transform', (d) => `translate(${xt(d.x)}, ${yt(d.y)})`)
      .on('mouseover', (event, d) => {
        d3.select(`#mpp${Math.round(1000 * d.x)}`)
          .attr('stroke-opacity', '1.0');
        d3.select(`#bpt${Math.round(1000 * d.x)}`)
          .style('fill', 'blue');
        const tipParams = { d, layout: this.layout, yFactor: this.yTransformFactor };
        this.tip.show(tipParams, event.target);
      })
      .on('mouseout', (event, d) => {
        d3.select(`#mpp${Math.round(1000 * d.x)}`)
          .attr('stroke-opacity', '0.0');
        d3.select(`#bpt${Math.round(1000 * d.x)}`)
          .style('fill', '#228B22');
        const tipParams = { d, layout: this.layout, yFactor: this.yTransformFactor };
        this.tip.hide(tipParams, event.target);
      })
      .on('click', (event, d) => this.onClickPecker(event, d));
  }

  drawInteg(integrationState) {
    const {
      sameXY, sameLySt, sameItSt, sameData,
    } = this.shouldUpdate;
    if (sameXY && sameLySt && sameItSt && sameData) return;

    const { integrations } = integrationState;
    const selectedIntegration = integrations[this.jcampIdx];
    if (selectedIntegration === false || selectedIntegration === undefined) {
      Object.assign(this, {
        integrationSplitTargets: { stack: [], shift: 0, ignoreRef: false },
      });
      const itgs = [];
      const igbp = this.tags.igbPath.selectAll('path').data(itgs);
      igbp.exit()
        .attr('class', 'exit')
        .remove();
      const igcp = this.tags.igcPath.selectAll('path').data(itgs);
      igcp.exit()
        .attr('class', 'exit')
        .remove();

      const igtp = this.tags.igtPath.selectAll('text').data(itgs);
      igtp.exit()
        .attr('class', 'exit')
        .remove();
      this.drawVisualSplitLines([], 0, false);
      return;
    }

    const {
      stack, refArea, refFactor, shift,
    } = selectedIntegration;

    const isDisable = Cfg.btnCmdIntg(this.layout);
    const ignoreRef = Format.isHplcUvVisLayout(this.layout);
    const itgs = isDisable ? [] : stack;
    const { showIntegSplit, igBarData } = buildIntegrationBarData(this.layout, itgs);
    Object.assign(this, {
      integrationSplitTargets: { stack: itgs, shift, ignoreRef },
    });

    const igbp = this.tags.igbPath.selectAll('path').data(igBarData);
    igbp.exit()
      .attr('class', 'exit')
      .remove();
    const igcp = this.tags.igcPath.selectAll('path').data(igBarData);
    igcp.exit()
      .attr('class', 'exit')
      .remove();

    const igtp = this.tags.igtPath.selectAll('text').data(itgs);
    igtp.exit()
      .attr('class', 'exit')
      .remove();

    if (itgs.length === 0 || isDisable) {
      // remove drawn area under curve
      const auc = this.tags.aucPath.selectAll('path').data(stack);
      auc.exit()
        .attr('class', 'exit')
        .remove();
      auc.merge(auc);
      this.drawVisualSplitLines(showIntegSplit ? itgs : [], shift, ignoreRef);
      return;
    }

    if (ignoreRef) {
      this.drawAUC(stack, shift);
    } else {
      // rescale for zoom
      const { xt } = TfRescale(this);

      const dh = 50;
      const integBar = (data) => (
        d3.line()([
          [xt(data.xL - shift), dh],
          [xt(data.xL - shift), dh - 10],
          [xt(data.xL - shift), dh - 5],
          [xt(data.xU - shift), dh - 5],
          [xt(data.xU - shift), dh - 10],
          [xt(data.xU - shift), dh],
        ])
      );

      igbp.enter()
        .append('path')
        .attr('class', 'igbp')
        .attr('fill', 'none')
        .attr('stroke', '#228B22')
        .attr('stroke-width', 2)
        .merge(igbp)
        .attr('id', (d) => `igbp${itgIdTag(d)}`)
        .attr('d', (d) => integBar(d))
        .on('mouseover', (event, d) => {
          d3.select(`#igbp${itgIdTag(d)}`)
            .attr('stroke', 'blue');
          d3.select(`#igbc${itgIdTag(d)}`)
            .attr('stroke', 'blue');
          d3.select(`#igtp${itgIdTag(d)}`)
            .style('fill', 'blue');
        })
        .on('mouseout', (event, d) => {
          d3.select(`#igbp${itgIdTag(d)}`)
            .attr('stroke', '#228B22');
          d3.select(`#igbc${itgIdTag(d)}`)
            .attr('stroke', '#228B22');
          d3.select(`#igtp${itgIdTag(d)}`)
            .style('fill', '#228B22');
          if (showIntegSplit) this.clearSplitPreview();
        })
        .on('mousemove', showIntegSplit
          ? (event, d) => this.onIntegrationMouseMove(event, d, shift, ignoreRef)
          : null)
        .on('click', (event, d) => this.onClickIntegrationTarget(event, d));

      const integCurve = (border) => {
        const { xL, xU } = border;
        const [nXL, nXU] = [xL - shift, xU - shift];
        const ps = this.data.filter((d) => d.x > nXL && d.x < nXU);
        const kMax = this.data[this.data.length - 1].k;
        if (!ps[0]) return null;
        const kRef = ps[0].k;
        if (!this.reverseXAxis(this.layout)) {
          return d3.line()
            .x((d) => xt(d.x))
            .y((d) => 100 - (kRef - d.k) * 400 / kMax)(ps);
        }
        return d3.line()
          .x((d) => xt(d.x))
          .y((d) => 300 - (d.k - kRef) * 400 / kMax)(ps);
      };

      igcp.enter()
        .append('path')
        .attr('class', 'igcp')
        .attr('fill', 'none')
        .attr('stroke', '#228B22')
        .attr('stroke-width', 2)
        .merge(igcp)
        .attr('id', (d) => `igbc${itgIdTag(d)}`)
        .attr('d', (d) => integCurve(d))
        .on('mouseover', (event, d) => {
          d3.select(`#igbp${itgIdTag(d)}`)
            .attr('stroke', 'blue');
          d3.select(`#igbc${itgIdTag(d)}`)
            .attr('stroke', 'blue');
          d3.select(`#igtp${itgIdTag(d)}`)
            .style('fill', 'blue');
        })
        .on('mouseout', (event, d) => {
          d3.select(`#igbp${itgIdTag(d)}`)
            .attr('stroke', '#228B22');
          d3.select(`#igbc${itgIdTag(d)}`)
            .attr('stroke', '#228B22');
          d3.select(`#igtp${itgIdTag(d)}`)
            .style('fill', '#228B22');
          if (showIntegSplit) this.clearSplitPreview();
        })
        .on('mousemove', showIntegSplit
          ? (event, d) => this.onIntegrationMouseMove(event, d, shift, ignoreRef)
          : null)
        .on('click', (event, d) => this.onClickIntegrationTarget(event, d));

      igtp.enter()
        .append('text')
        .attr('class', 'igtp')
        .attr('font-family', 'Helvetica')
        .style('font-size', '12px')
        .attr('fill', '#228B22')
        .style('text-anchor', 'middle')
        .merge(igtp)
        .attr('id', (d) => `igtp${itgIdTag(d)}`)
        .text((d) => calcArea(d, refArea, refFactor, ignoreRef))
        .attr('transform', (d) => `translate(${xt((d.xL + d.xU) / 2 - shift)}, ${dh - 12})`)
        .on('mouseover', (event, d) => {
          d3.select(`#igbp${itgIdTag(d)}`)
            .attr('stroke', 'blue');
          d3.select(`#igbc${itgIdTag(d)}`)
            .attr('stroke', 'blue');
          d3.select(`#igtp${itgIdTag(d)}`)
            .style('fill', 'blue');
        })
        .on('mouseout', (event, d) => {
          d3.select(`#igbp${itgIdTag(d)}`)
            .attr('stroke', '#228B22');
          d3.select(`#igbc${itgIdTag(d)}`)
            .attr('stroke', '#228B22');
          d3.select(`#igtp${itgIdTag(d)}`)
            .style('fill', '#228B22');
          if (showIntegSplit) this.clearSplitPreview();
        })
        .on('mousemove', showIntegSplit
          ? (event, d) => this.onIntegrationMouseMove(event, d, shift, ignoreRef)
          : null)
        .on('click', (event, d) => this.onClickIntegrationTarget(event, d));
    }
    this.drawVisualSplitLines(showIntegSplit ? itgs : [], shift, ignoreRef);
  }

  clearMtply() {
    // Nothing to draw: still empty the layers, or the previous spectrum's multiplets stay drawn.
    this.tags.mpybPath.selectAll('path').remove();
    this.tags.mpyt1Path.selectAll('text').remove();
    this.tags.mpyt2Path.selectAll('text').remove();
    this.tags.mpypPath.selectAll('path').remove();
  }

  drawMtply(mtplySt) {
    const { sameXY, sameLySt, sameMySt } = this.shouldUpdate;
    if (sameXY && sameLySt && sameMySt) return;

    const { multiplicities } = mtplySt;
    const selectedMulti = multiplicities[this.jcampIdx];

    if (selectedMulti === false || selectedMulti === undefined) {
      this.clearMtply();
      return;
    }

    const {
      stack = [], smExtext = false, shift = 0,
    } = selectedMulti || {};
    const hasValidExtent = (extent) => (
      extent
      && Number.isFinite(extent.xL)
      && Number.isFinite(extent.xU)
    );
    const mpys = stack.filter((m) => hasValidExtent(m?.xExtent));
    const isDisable = Cfg.btnCmdMpy(this.layout);
    if (mpys.length === 0 || isDisable) {
      this.clearMtply();
      return;
    }
    const activeExtent = hasValidExtent(smExtext) ? smExtext : mpys[0].xExtent;
    // rescale for zoom
    const { xt } = TfRescale(this);

    const mpyb = this.tags.mpybPath.selectAll('path').data(mpys);
    mpyb.exit()
      .attr('class', 'exit')
      .remove();
    const mpyt1 = this.tags.mpyt1Path.selectAll('text').data(mpys);
    mpyt1.exit()
      .attr('class', 'exit')
      .remove();
    const mpyt2 = this.tags.mpyt2Path.selectAll('text').data(mpys);
    mpyt2.exit()
      .attr('class', 'exit')
      .remove();
    let mPeaks = mpys.map((m) => {
      const { peaks, xExtent } = m;
      const safePeaks = Array.isArray(peaks) ? peaks : [];
      return safePeaks
        .filter((p) => Number.isFinite(p?.x) && Number.isFinite(p?.y))
        .map((p) => Object.assign({}, p, { xExtent }));
    });
    mPeaks = [].concat(...mPeaks);
    const mpyp = this.tags.mpypPath.selectAll('path').data(mPeaks);
    mpyp.exit()
      .attr('class', 'exit')
      .remove();

    const height = this.h;
    const dh = Math.abs(0.06 * height);
    const mpyBar = (data) => (
      d3.line()([
        [xt(data.xExtent.xL - shift), height - dh],
        [xt(data.xExtent.xL - shift), height - dh - 10],
        [xt(data.xExtent.xL - shift), height - dh - 5],
        [xt(data.xExtent.xU - shift), height - dh - 5],
        [xt(data.xExtent.xU - shift), height - dh - 10],
        [xt(data.xExtent.xU - shift), height - dh],
      ])
    );

    const mpyColor = (d) => {
      const { xL, xU } = d.xExtent;
      return (activeExtent.xL === xL && activeExtent.xU === xU) ? 'purple' : '#DA70D6';
    };

    mpyb.enter()
      .append('path')
      .attr('class', 'mpyb')
      .attr('fill', 'none')
      .attr('stroke-width', 2)
      .merge(mpyb)
      .attr('stroke', (d) => mpyColor(d))
      .attr('id', (d) => `mpyb${mpyIdTag(d)}`)
      .attr('d', (d) => mpyBar(d))
      .on('mouseover', (event, d) => {
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
      })
      .on('mouseout', (event, d) => {
        const dColor = mpyColor(d);
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', dColor);
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', dColor);
      })
      .on('click', (event, d) => this.onClickTarget(event, d));

    mpyt1.enter()
      .append('text')
      .attr('class', 'mpyt1')
      .attr('font-family', 'Helvetica')
      .style('font-size', '12px')
      .style('text-anchor', 'middle')
      .merge(mpyt1)
      .attr('fill', (d) => mpyColor(d))
      .attr('id', (d) => `mpyt1${mpyIdTag(d)}`)
      .text((d) => `${calcMpyCenter(d.peaks, shift, d.mpyType).toFixed(3)}`)
      .attr('transform', (d) => `translate(${xt((d.xExtent.xL + d.xExtent.xU) / 2 - shift)}, ${height - dh + 12})`)
      .on('mouseover', (event, d) => {
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
      })
      .on('mouseout', (event, d) => {
        const dColor = mpyColor(d);
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', dColor);
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', dColor);
      })
      .on('click', (event, d) => this.onClickTarget(event, d));

    mpyt2.enter()
      .append('text')
      .attr('class', 'mpyt2')
      .attr('font-family', 'Helvetica')
      .style('font-size', '12px')
      .style('text-anchor', 'middle')
      .merge(mpyt2)
      .attr('fill', (d) => mpyColor(d))
      .attr('id', (d) => `mpyt2${mpyIdTag(d)}`)
      .text((d) => `(${d.mpyType})`)
      .attr('transform', (d) => `translate(${xt((d.xExtent.xL + d.xExtent.xU) / 2 - shift)}, ${height - dh + 24})`)
      .on('mouseover', (event, d) => {
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
      })
      .on('mouseout', (event, d) => {
        const dColor = mpyColor(d);
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', dColor);
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', dColor);
      })
      .on('click', (event, d) => this.onClickTarget(event, d));

    const mpypH = height - dh;
    const mpypPath = (pk) => (
      [
        { x: xt(pk.x - shift) - 0.5, y: mpypH - 5 },
        { x: xt(pk.x - shift) - 0.5, y: mpypH - 20 },
        { x: xt(pk.x - shift) + 0.5, y: mpypH - 20 },
        { x: xt(pk.x - shift) + 0.5, y: mpypH - 5 },
      ]
    );
    // const faktor = layoutSt === LIST_LAYOUT.IR ? -1 : 1;
    const lineSymbol = d3.line()
      .x((d) => d.x)
      .y((d) => d.y);

    mpyp.enter()
      .append('path')
      .attr('class', 'mpyp')
      .attr('fill', 'none')
      .merge(mpyp)
      .attr('stroke', (d) => mpyColor(d))
      .attr('d', (d) => lineSymbol(mpypPath(d)))
      .attr('id', (d) => `mpyp${mpyIdTag(d)}`)
      .on('mouseover', (event, d) => {
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', 'blue');
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', 'blue');
      })
      .on('mouseout', (event, d) => {
        const dColor = mpyColor(d);
        d3.selectAll(`#mpyb${mpyIdTag(d)}`)
          .attr('stroke', dColor);
        d3.selectAll(`#mpyt1${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyt2${mpyIdTag(d)}`)
          .style('fill', dColor);
        d3.selectAll(`#mpyp${mpyIdTag(d)}`)
          .attr('stroke', dColor);
      })
      .on('click', (event, d) => this.onClickTarget(event, d));
  }

  drawRef() {
    // rescale for zoom
    const { xt, yt } = TfRescale(this);

    const ccp = this.ref.selectAll('path')
      .data(this.tSfPeaks);

    ccp.exit()
      .attr('class', 'exit')
      .remove();

    const linePath = [
      { x: -0.5, y: 10 },
      { x: -4, y: -20 },
      { x: 4, y: -20 },
      { x: 0.5, y: 10 },
    ];
    const faktor = Format.isIrLayout(this.layout) ? -1 : 1;
    const lineSymbol = d3.line()
      .x((d) => d.x)
      .y((d) => faktor * d.y)(linePath);

    ccp.enter()
      .append('path')
      .attr('d', lineSymbol)
      .attr('class', 'enter-ref')
      .attr('fill', 'green')
      .attr('fill-opacity', 0.8)
      .merge(ccp)
      .attr('transform', (d) => `translate(${xt(d.x)}, ${yt(d.y)})`);
  }

  reverseXAxis(layoutSt) {
    return !Format.isNonReversedXLayout(layoutSt);
  }

  create({
    curveSt,
    filterSeed, filterPeak, tTrEndPts, tSfPeaks,
    editPeakSt, layoutSt,
    sweepExtentSt, isUiAddIntgSt, isUiSplitIntgSt, isUiVisualSplitIntgSt, isUiNoBrushSt,
    cyclicvoltaSt,
    integrationSt, mtplySt, uiSt, yInvertedSt = false,
  }) {
    this.uiSt = uiSt;
    this.graphIndex = uiSt?.zoom?.graphIndex;
    this.svg = d3.select(this.rootKlass).select('.d3Svg');
    MountMainFrame(this, 'focus');
    MountClip(this);

    const { curveIdx, isShowAllCurve } = curveSt;
    const jcampIdx = curveIdx;
    this.isShowAllCurves = isShowAllCurve;

    this.root = d3.select(this.rootKlass).selectAll('.focus-main');
    this.scales = InitScale(this, this.reverseXAxis(layoutSt), yInvertedSt);
    this.setTip();
    this.setDataParams(filterSeed, filterPeak, tTrEndPts, tSfPeaks, layoutSt, cyclicvoltaSt, jcampIdx);
    Object.assign(this, { isUiSplitIntgSt, isUiVisualSplitIntgSt });
    if (!isUiSplitIntgSt && !isUiVisualSplitIntgSt) this.clearSplitPreview();
    MountCompass(this);

    this.axis = MountAxis(this);
    this.path = MountPath(this, this.pathColor);
    [this.thresLineUp, this.thresLineDw] = MountThresLine(this, 'green');
    this.grid = MountGrid(this);
    this.tags = MountTags(this);
    this.ref = MountRef(this);
    MountAxisLabelX(this);
    MountAxisLabelY(this);

    if (this.data && this.data.length > 0) {
      this.setConfig(sweepExtentSt);
      this.drawLine();
      this.drawThres();
      this.drawGrid();
      this.drawOtherLines(layoutSt);
      this.drawPeaks(editPeakSt);
      this.drawRef();
      this.drawPeckers();
      this.drawInteg(integrationSt);
      this.drawMtply(mtplySt);
    }
    MountBrush(this, isUiAddIntgSt, isUiNoBrushSt);
    this.resetShouldUpdate(editPeakSt);
  }

  update({
    entities, curveSt,
    filterSeed, filterPeak, tTrEndPts, tSfPeaks,
    editPeakSt, layoutSt,
    sweepExtentSt, isUiAddIntgSt, isUiSplitIntgSt, isUiVisualSplitIntgSt, isUiNoBrushSt, cyclicvoltaSt,
    integrationSt, mtplySt, uiSt, yInvertedSt = false,
  }) {
    this.uiSt = uiSt;
    this.root = d3.select(this.rootKlass).selectAll('.focus-main');
    this.scales = InitScale(this, this.reverseXAxis(layoutSt), yInvertedSt);
    this.graphIndex = uiSt?.zoom?.graphIndex;

    const { curveIdx, isShowAllCurve } = curveSt;
    const jcampIdx = curveIdx;
    this.isShowAllCurves = isShowAllCurve;
    this.entities = entities;

    this.setDataParams(filterSeed, filterPeak, tTrEndPts, tSfPeaks, layoutSt, cyclicvoltaSt, jcampIdx);
    Object.assign(this, { isUiSplitIntgSt, isUiVisualSplitIntgSt });
    if (!isUiSplitIntgSt && !isUiVisualSplitIntgSt) this.clearSplitPreview();

    if (this.data && this.data.length > 0) {
      this.setConfig(sweepExtentSt);
      this.getShouldUpdate(editPeakSt);
      this.drawLine();
      this.drawThres();
      this.drawGrid();
      this.drawOtherLines(layoutSt);
      this.drawPeaks(editPeakSt);
      this.drawRef();
      this.drawPeckers();
      this.drawInteg(integrationSt);
      this.drawMtply(mtplySt);
    }
    MountBrush(this, false, isUiNoBrushSt, this.uiSt, this.graphIndex);
    this.resetShouldUpdate(editPeakSt);
  }
}

export default MultiFocus;
